import { render, staticRenderFns } from "./DishChip.vue?vue&type=template&id=43fdde7c&scoped=true&"
import script from "./DishChip.vue?vue&type=script&lang=js&"
export * from "./DishChip.vue?vue&type=script&lang=js&"
import style0 from "./DishChip.vue?vue&type=style&index=0&id=43fdde7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fdde7c",
  null
  
)

component.options.__file = "DishChip.vue"
export default component.exports